import { Box } from "@mui/material";
import { IconChevronLeft } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/ui/Button";
import Text from "../../../components/ui/Text";
import { PaymentMethods, Receipts } from "./parts";

const MyPayments = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/payments");
  };

  return (
    <>
      {/* Responsive Back Button and Header */}
      <Box sx={{ mb: 3, display: { xs: "block", md: "none" } }}>
        <Button variant="back" onClick={handleBack} />
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 3 }}>
        <Box
          onClick={handleBack}
          sx={{
            display: { xs: "none", md: "flex" },
            alignItems: "center",
            cursor: "pointer",
            color: "#1890FF",
            "&:hover": {
              color: "#40A9FF",
            },
          }}
        >
          <IconChevronLeft size={20} />
        </Box>
        <Text variant="pageHeader">My payments</Text>
      </Box>

      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: "8px",
          p: { md: 3 },
          border: { md: "1px solid #e5e5e5" },
        }}
      >
        {/* Payment Methods Section */}
        <PaymentMethods />

        {/* Receipts Section */}
        <Receipts />
      </Box>
    </>
  );
};

export default MyPayments;
